import { useIntl } from 'react-intl';
import { BrandConfig } from '@sso/brand-configs';
import { formatSubstring } from '@sso/core-utils';
import { Link } from '@sso/components';
import { useTrafficPrefix, useBrandName } from '@sso/context-providers';

import { Configs } from '../types';

type Props = {
  brandConfig: BrandConfig;
  isResellerMigration: boolean;
  urls: Record<string, string>;
  configs: Configs;
  socialButtonsPresent: boolean;
  showFactorSelector: boolean;
};

export const LegalAgreement = ({
  isResellerMigration,
  urls,
  configs,
  brandConfig,
  socialButtonsPresent,
  showFactorSelector,
}: Props) => {
  const intl = useIntl();
  const trafficPrefix = useTrafficPrefix();
  const brandName = useBrandName();

  const getLegalStringKey = () => {
    if (isResellerMigration) {
      return 'MIGRATING_BRAND_RESELLER_CREATE_LEGAL_AGREEMENT';
    }
    if (configs.complete_account) {
      return 'COMPLETE_ACCOUNT_LEGAL_AGREEMENT';
    }
    if (socialButtonsPresent && showFactorSelector) {
      return 'CREATE_ACCOUNT_LEGAL_AGREEMENT_WITH_SOCIAL_LOGINS';
    }
    return 'CREATE_ACCOUNT_LEGAL_AGREEMENT_WITHOUT_SOCIAL_LOGINS';
  };

  const legalAgreement = intl.formatMessage({ id: getLegalStringKey() });
  const tosLink = brandConfig?.create?.redirect?.terms || urls.tos;
  const privacyLink = brandConfig?.create?.redirect?.privacy || urls.privacy;

  return formatSubstring(legalAgreement, {
    business_name: `${brandName}`,
    terms_and_conditions: (
      <Link
        id='tos-link'
        href={tosLink}
        dataEid={`${trafficPrefix}.tos.link`}
        target='_blank'
        key='tos'
        text={intl.formatMessage({ id: 'TERMS_AND_CONDITIONS' })}
      />
    ),
    terms_of_service: (
      <Link
        id='tos-link'
        href={tosLink}
        dataEid={`${trafficPrefix}.tos.link`}
        target='_blank'
        key='tos'
        text={intl.formatMessage({ id: 'TERMS_OF_SERVICE' })}
      />
    ),
    privacy_policy_label: (
      <Link
        id='privacy-link'
        href={privacyLink}
        dataEid={`${trafficPrefix}.privacy.link`}
        target='_blank'
        key='privacy'
        text={intl.formatMessage({ id: 'PRIVACY_POLICY_LABEL' })}
      />
    ),
  });
};
